// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chart-area-multi"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M20 17.2096L7 17.2096V16.5V16L12.3257 11.1739L15.3257 14.6739L20 10L20 17.2096Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 21H3V3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M20 10L20 17.2096L7 17.2096L7 16L12.3257 11.1739L15.3257 14.6739L20 10ZM20 10L19.9997 10.5M7 12.5L12.4997 7.49957L15.4997 10.9996L20 6.5V9.99957L15.3257 14.6735L12.3257 11.1735L7 15.9996L7 12.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChartAreaMultiIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-area-multi',
    ref,
    icon: element,
  },
));

ChartAreaMultiIcon.displayName = 'ChartAreaMultiIcon';

export default ChartAreaMultiIcon;
